import styled from 'styled-components';
import { Box } from '@mui/material';

export const Container = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  height: calc(100vh - ${({ theme }) => theme.navHeight});
`;
